module.exports = __webpack_public_path__ + "content/0314467322220a85863c27d00b673c5e.png";